import { AIntlStore, ELocale, type TTranslationsMap } from '@zennolab_platform/webui-sdk/dist/stores/IntlStore';
import { Service } from 'typedi';

import EN_TRANSLATIONS from '../locales/en.json';
import RU_TRANSLATIONS from '../locales/ru.json';
import ZH_TRANSLATIONS from '../locales/zh.json';

const APP_TRANSLATIONS_MAP: TTranslationsMap = {
  [ELocale.RU]: RU_TRANSLATIONS,
  [ELocale.EN]: EN_TRANSLATIONS,
  [ELocale.ZH]: ZH_TRANSLATIONS,
};

/** The admin's react-intl instance: its own strings (src/locales, generated from translations/*.resx) and webui-sdk's. */
@Service()
export class IntlStore extends AIntlStore {
  constructor() {
    super(ELocale.RU, ELocale.RU, APP_TRANSLATIONS_MAP);
  }
}
